var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breakdown-legend__container" },
    [
      _c("span", {
        directives: [
          { name: "t", rawName: "v-t", value: "LABEL", expression: "'LABEL'" }
        ],
        staticClass: "m-r-5"
      }),
      _vm._v(" "),
      _vm._l(_vm.breakdown, function(groupBy, index) {
        return _c(
          "span",
          {
            key: groupBy.fieldName,
            staticClass: "group-level",
            class: { root: index === 0 }
          },
          [
            _c(
              "span",
              {
                staticClass: "label label-default",
                attrs: { id: "level" + index },
                on: { click: () => _vm.showPopover(index) }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top.hover",
                        value: {
                          text: _vm.$t("UPDATE_LEVEL_TT"),
                          customClass: "group-level__tooltip"
                        },
                        expression:
                          "{text: $t('UPDATE_LEVEL_TT'), customClass: 'group-level__tooltip'}",
                        modifiers: { top: true, hover: true }
                      }
                    ]
                  },
                  [_vm._v(_vm._s(groupBy.displayName) + " ")]
                ),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-angle-down m-l-5",
                  class: { "m-r-3": index !== 0 }
                }),
                _vm._v(" "),
                index > 0
                  ? _c("i", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.hover",
                          value: {
                            text: _vm.$t("DELETE_LEVEL_TT"),
                            customClass: "group-level__tooltip"
                          },
                          expression:
                            "{text: $t('DELETE_LEVEL_TT'), customClass: 'group-level__tooltip'}",
                          modifiers: { top: true, hover: true }
                        }
                      ],
                      staticClass: "fa fa-times group-level__delete m-l-5",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return (() => _vm.deleteLevel(index)).apply(
                            null,
                            arguments
                          )
                        }
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "popover",
              {
                attrs: {
                  target: "#level" + index,
                  trigger: "manual",
                  placement: "bottom",
                  "custom-class": "breakdown-legend__popover"
                },
                on: {
                  show: function($event) {
                    _vm.popoverVisible[index] = true
                  },
                  hide: function($event) {
                    _vm.popoverVisible[index] = false
                  }
                },
                model: {
                  value: _vm.popoverOpen[index],
                  callback: function($$v) {
                    _vm.$set(_vm.popoverOpen, index, $$v)
                  },
                  expression: "popoverOpen[index]"
                }
              },
              [
                _c(
                  "template",
                  { slot: "popover" },
                  [
                    _c("InsightsGroupByDropdown", {
                      staticClass: "insights-group-by-dropdown",
                      attrs: {
                        "available-group-bys": _vm.availableGroupBys,
                        index: index,
                        "focus-dropdown": _vm.popoverVisible[index],
                        "tag-grouping-already-selected":
                          _vm.tagGroupingAlreadySelected
                      },
                      on: { input: _vm.onGroupByChange, blur: _vm.hidePopover }
                    })
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("span", { staticClass: "level-separator" }, [_vm._v(">")])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "group-level add-level" },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.hover",
                  value: _vm.$t("ADD_LEVEL_TT"),
                  expression: "$t('ADD_LEVEL_TT')",
                  modifiers: { top: true, hover: true }
                }
              ],
              ref: "addLevel",
              staticClass: "label label-default",
              attrs: { id: "level" + _vm.numBreakdownLevels },
              on: { click: () => _vm.showPopover(_vm.numBreakdownLevels) }
            },
            [
              _c("i", { staticClass: "fa fa-plus p-r-5" }),
              _vm._v(" " + _vm._s(_vm.$t("LEVEL")))
            ]
          ),
          _vm._v(" "),
          _c(
            "popover",
            {
              attrs: {
                target: _vm.$refs.addLevel,
                trigger: "manual",
                placement: "bottom",
                "custom-class": "breakdown-legend__popover"
              },
              on: {
                show: function($event) {
                  _vm.popoverVisible[_vm.numBreakdownLevels] = true
                },
                hide: function($event) {
                  _vm.popoverVisible[_vm.numBreakdownLevels] = false
                }
              },
              model: {
                value: _vm.popoverOpen[_vm.numBreakdownLevels],
                callback: function($$v) {
                  _vm.$set(_vm.popoverOpen, _vm.numBreakdownLevels, $$v)
                },
                expression: "popoverOpen[numBreakdownLevels]"
              }
            },
            [
              _c(
                "template",
                { slot: "popover" },
                [
                  _c("InsightsGroupByDropdown", {
                    staticClass: "insights-group-by-dropdown",
                    attrs: {
                      "available-group-bys": _vm.availableGroupBys,
                      index: _vm.numBreakdownLevels,
                      "focus-dropdown":
                        _vm.popoverVisible[_vm.numBreakdownLevels],
                      "tag-grouping-already-selected":
                        _vm.tagGroupingAlreadySelected
                    },
                    on: { input: _vm.onGroupByChange, blur: _vm.hidePopover }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }